var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStarHalf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    id: "StarHalf",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#f9b84e",
    d: "M7.55167 1.77872L5.75771 5.41369L1.74627 5.99659C1.33616 6.05618 1.17241 6.56016 1.46917 6.84943L4.37187 9.67887L3.68663 13.6741C3.61658 14.0825 4.04529 14.394 4.41211 14.2012L8.00004 12.3149L11.588 14.2012C11.9548 14.394 12.3835 14.0825 12.3134 13.6741L11.6282 9.67887L14.5309 6.84943C14.8277 6.56016 14.6639 6.05618 14.2538 5.99659L10.2424 5.41369L8.44841 1.77872C8.265 1.40709 7.73508 1.40709 7.55167 1.77872ZM8 11.25L8.00004 3.12978L9.46198 6.09198C9.53481 6.23955 9.67559 6.34183 9.83844 6.3655L13.1074 6.84051L10.742 9.14626C10.6241 9.26113 10.5704 9.42663 10.5982 9.58883L11.1566 12.8446L8.23271 11.3074C8.15987 11.2691 8.07993 11.25 8 11.25Z",
    className: "color212121 svgShape"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarHalf);
export default __webpack_public_path__ + "static/media/star-half.1fb90c36e1903990706e0303d8bda1cd.svg";
export { ForwardRef as ReactComponent };